<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TNAAs7/tc-custom/9781514003565.jpg?1696024481022" alt="This image is the cover for the book Young, Gifted, and Black"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Young, Gifted, and Black
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>"Young, gifted and black,<br/> Open your heart to what I mean . . . "</strong> </p> <p>Nina Simone's popular anthem from the civil rights movement speaks to both the celebrations and trials of the Black experience.</p> <p> <em>Young, Gifted, and Black</em> gives voice to the real-life stories of Black millennials and younger adults. If life was a race, it's assumed that every runner has a fair shot at winning. However, it's not always the case for young, gifted, and Black folks. Sheila Wise Rowe goes beyond the common narrative that focuses solely on their success or struggle. Her stories of celebration and lament point toward hope, joy, and healing.</p> <p>Drawing from her years of experience in counseling trauma and abuse survivors, she provides stories, reflections, and tools for Black readers of all ages and their allies. These stories offer an opportunity to explore, reflect, and journey toward healing from the barriers that affect their lives, the lives of their children, and their communities.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sheila Wise Rowe
      </h2>
      
      <p class="authorDescription body article"><p>Sheila Wise Rowe, the author of <em>Healing Racial Trauma</em>, holds a master's degree in counseling psychology. She has ministered to abuse and trauma survivors in the United States for over twenty-five years and in Johannesburg, South Africa, for a decade. Sheila also taught counseling and trauma-related courses. She and her family live in the Boston area, where she is a writer, speaker, and spiritual director.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c073f8d